import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '@dental-ui/ui';

@Component({
  selector: 'lib-portal-not-authorized',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonComponent],
  templateUrl: './portal-not-authorized.component.html',
  styleUrl: './portal-not-authorized.component.scss',
})
export class PortalNotAuthorizedComponent {}
